module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/sammy-keane-5734192b0bc6801b7f84644f9bd94d53.jpg";